import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_tinymce = _resolveComponent("vue-tinymce")!

  return (_openBlock(), _createBlock(_component_vue_tinymce, {
    "api-key": $data.apiKey,
    modelValue: _ctx.valueLocal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valueLocal) = $event)),
    init: $data.options
  }, null, 8 /* PROPS */, ["api-key", "modelValue", "init"]))
}